import { getAxios } from '../axios';
import {
  addParam,
  errorCatch,
  getNotificationId,
  getTokenHeaders
} from '../helper';
import {
  ENDPOINT_CLIENT_TICKETS,
} from '../../config/endpoints';
import { Messages } from '../../config';
import { store } from '../../store/store';
import { displayNotification } from '../../store/actions/notification';
import { NOTIFICATION_SUCCESS } from '../../store/actions/types';

/**
 * Get list of client tickets
 * @param {object} payload
 * @param {boolean} payload.hideNotification
 * @param {boolean} [payload.disablePagination]
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
export function getTickets(payload) {
  return getAxios( payload.hideNotification )
    .get(
      addParam( ENDPOINT_CLIENT_TICKETS, {
        "{ticket}": "",
      } ),
      getTokenHeaders( payload.pagination || null )
    )
    .then( (response) => {
      return response && response.data ? response.data : null;
    } )
    .catch( (e) => {
      errorCatch( e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      } );

      return e.response;
    } );
}

/**
 * Get details of client ticket
 * @param {object} payload
 * @param {string} payload.ticketId
 * @param {string} payload.notificationId
 * @param {object} payload.pagination
 * @param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
export function getTicketDetails(payload) {
  return getAxios()
    .get(
      addParam( ENDPOINT_CLIENT_TICKETS, {
        "{ticket}": payload.ticketId,
      } ),
      getTokenHeaders(payload.pagination)
    )
    .then( (response) => {

      return response && response.data ? response.data : null;

    } )
    .catch( (e) => {
      errorCatch( e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId( payload ) );

      return e.response;
    } );
}

/**
 * Update a ticket
 * @param {object} payload
 * @param {number} payload.ticket
 * @param {string} [payload.notificationId]
 * @param {object} payload.data
 * @param {string} payload.data.status
 * @param {string} payload.data.reason
 * @param {string} payload.data.organization_id
 * @returns {Promise<T>}
 */
export function updateTicket(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_CLIENT_TICKETS,
      {
        '{ticket}': payload.ticket,
      }
    ),
    payload.data,
    getTokenHeaders()
  )
    .then(response => {
      if (response && response.data) {
        store.dispatch(
          displayNotification(
            NOTIFICATION_SUCCESS,
            Messages.UPDATE_RESOURCE_SUCCESS,
            payload.notificationId
          )
        );

        return response.data;
      }

      return null;
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}

